import React from 'react'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '../ui/sheet'
import { Download, Loader2, MessageCircleIcon, Paperclip } from 'lucide-react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table'
import { useMutation } from 'react-query'
import axios from 'src/axios/axios'
import { downloadFile } from 'src/functions/actions/documents'
import toast from 'react-hot-toast'
import { YYYYMMDDtoDate } from 'src/functions/format'
import { format } from 'date-fns'
import CommunicationComponent from './communication/Communication'
import { useTranslation } from 'react-i18next'

type Props = {
    communication?: Communcation[] | null
    refetch?: () => void
    document?: DocumentObject
}

const Communication = ({communication, document, refetch}:Props) => {
  const { t } = useTranslation()

  return (
    <Sheet>
        <SheetTrigger asChild>
          <button className='relative flex items-center justify-center w-10 h-10 bg-white rounded-full hover:bg-slate-200'>
            {communication && <div className='absolute top-0 left-0 flex items-center justify-center w-4 h-4 rounded-full bg-primary'><p className='text-xs text-primary-foreground'>{communication?.length || 0}</p></div>}
            <MessageCircleIcon className='w-5 text-slate-500'/>
          </button>
        </SheetTrigger>
        <SheetContent className='md:max-w-[600px] md:w-full'>
            <SheetTitle>{t('Communicatie')}</SheetTitle>
            <CommunicationComponent communication={communication} document={document} onSuccess={()=>{refetch && refetch()}}/>
        </SheetContent>
    </Sheet>
  )
}

export default Communication